export const profileData = {
  name: "Bhargavprasad Vana",
  role: "Full Stack Developer",
  summary:
    "Building scalable web applications with the MERN Stack. Passionate about creating elegant solutions and exceptional user experiences.",
  github: "https://github.com/Bhargavprasad-data",
  linkedin: "https://www.linkedin.com/in/vana-bhargav-prasad-57352b399/",
  leetcode: "https://leetcode.com/u/Bhargavprasad_vana/",
  email: "bhargavvana80@gmail.com",
  photo:
    "/profile/profile.jpg", // place your image at public/profile/profile.jpg
  resumeLink: "/Vana_Bhargav_Prasad_Resume_2027.pdf" // place your resume at public/Vana_Bhargav_Prasad_Resume_2027.pdf
};


